import React, { useEffect } from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import { GlobalDebug } from "./hooks/removeConsoles";
import SignUp from "./pages/SignUp";
import { AuthProvider } from "./auth/AuthContext";
import { ThemeContextProvider } from "./context/ThemeContext";
import RegisterationTemp from "./pages/RegisterationTemp";
import Menu from "./pages/support/Menu";
import Staff from "./pages/support/Staff";
import Ratings from "./pages/Ratings";
import PurchaseListPage from "./pages/PurchaseListPage";
import PasswordResetRequest from "./pages/PasswordResetRequest";
import ScrollToTop from "./components/ScrollToTop";
import { createTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import PasswordReset from "./pages/PasswordReset";
import Header from "./components/Header";
import Settings from "./pages/settings/Index";
import EmailChangeRequest from "./pages/settings/EmailChangeRequest";
import EmailChangeComplete from "./pages/settings/EmailChangeComplete";
import EmailChangeRequestComplete from "./pages/settings/EmailChangeRequestComplete";
import PasswordChange from "./pages/settings/PasswordChange";
import PasswordChangeComplete from "./pages/settings/PasswordChangeComplete";
import PasswordResetComplete from "./pages/PasswordResetComplete";
import BuyPage from "./pages/BuyPage";
import RatingComplete from "./pages/RatingComplete";
import BuyComplete from "./pages/BuyComplete";
import ErrorPage from "./pages/ErrorPage";
import { UserDataProvider } from "./context/UserDataContext";
import GetCoupon from "./pages/GetCoupon";
import ReservationDateChangeComplete from "./pages/ReservationDateChangeComplete";
import HandleError from "./utils/HandleError";
import Footer from "./components/Footer";
import { Environment } from "./utils/environments";
function App() {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#d63466",
      },
      secondary: {
        main: "#2683c3",
        light: "#2683c3",
      },
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 768,
        lg: 1280,
        xl: 1920,
      },
    },
  });
  const noReplyEmail = "noreply@jibun-it.jp";
  useEffect(() => {
    if (Environment.getBuildType() == "prod") {
      GlobalDebug(false, false);
    }
  }, []);
  return (
    <div className="App">
      <AuthProvider>
        <ThemeContextProvider>
          <UserDataProvider>
            <ThemeProvider theme={theme}>
              <Header />
              <ScrollToTop />
              <div className="body-wrapper">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/signup" element={<SignUp />} />
                  {/* <Route path="/get-ticket" element={<GetTicketPage />} /> */}
                  <Route path="/support/menu" element={<Menu />} />
                  <Route
                    path="/registeration-temp"
                    element={<RegisterationTemp email={noReplyEmail} />}
                  />
                  <Route path="/support/staff" element={<Staff />} />
                  <Route
                    path="/support/reservation-date-change"
                    element={<Staff />}
                  />

                  <Route path="/rating" element={<Ratings />} />
                  <Route path="/purchase-list" element={<PurchaseListPage />} />
                  <Route
                    path="/password-reset-request"
                    element={<PasswordResetRequest />}
                  />
                  <Route
                    path="/password-reset"
                    element={<PasswordReset email={noReplyEmail} />}
                  />
                  <Route path="/settings" element={<Settings />} />
                  <Route
                    path="/settings/email-change-request"
                    element={<EmailChangeRequest />}
                  ></Route>
                  <Route
                    path="/settings/email-change-request-complete"
                    element={
                      <EmailChangeRequestComplete email={noReplyEmail} />
                    }
                  ></Route>
                  <Route
                    path="/settings/email-change-complete"
                    element={<EmailChangeComplete />}
                  ></Route>
                  <Route
                    path="/settings/password-change"
                    element={<PasswordChange />}
                  ></Route>
                  <Route
                    path="/settings/password-change-complete"
                    element={<PasswordChangeComplete />}
                  />
                  <Route
                    path="/password-reset-complete"
                    element={<PasswordResetComplete />}
                  />
                  <Route path="/buy" element={<BuyPage />} />
                  <Route path="/rating-complete" element={<RatingComplete />} />
                  <Route
                    path="/buy-complete"
                    element={<BuyComplete email={noReplyEmail} />}
                  />
                  <Route
                    path="/reservationdate-change-complete"
                    element={
                      <ReservationDateChangeComplete email={noReplyEmail} />
                    }
                  />
                  <Route path="/error" element={<ErrorPage />} />

                  <Route path="/get-coupon" element={<GetCoupon />} />
                  <Route path="*" element={<HandleError errorCode={"404"} />} />
                </Routes>
              </div>
              <Footer />
            </ThemeProvider>
          </UserDataProvider>
        </ThemeContextProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
